import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from "@mui/material/MenuItem";
import VideocamIcon from '@mui/icons-material/Videocam';

const VideoSettings = ({ selectedVideoDevice, setSelectedVideoDevice, selectedAudioInputDevice, selectedAudioOutputDevice, myVideoSettingsRef }) => {
  const [temporalVideoDevice, setTemporalVideoDevice] = useState(selectedVideoDevice)
  const [videoDevices, setVideoDevices] = useState([]);

  useEffect(() => {
    // Fetch available video input devices using navigator.mediaDevices
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      navigator.mediaDevices.enumerateDevices().then((devices) => {
        const videoInputDevices = devices.filter(
          (device) => device.kind === "videoinput"
        );

        // Check if there are any video input devices available
        if (videoInputDevices.length > 0) {
          setVideoDevices(videoInputDevices);
          setSelectedVideoDevice(selectedVideoDevice || videoInputDevices[0].deviceId); // Set the first device as default
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (myVideoSettingsRef.current || selectedVideoDevice) {
      // Access the user media based on the selected video device
      navigator.mediaDevices.getUserMedia({
        audio: {
          deviceId: {
            input: selectedAudioInputDevice ? { exact: selectedAudioInputDevice } : undefined,
            output: selectedAudioOutputDevice ? { exact: selectedAudioOutputDevice } : undefined,
          },
        },
        video: { deviceId: selectedVideoDevice ? { exact: selectedVideoDevice } : undefined },
      }
      )
        .then((stream) => {
          myVideoSettingsRef.current.srcObject = stream;
        })
        .catch((error) => {
          console.error("Error accessing user media:", error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myVideoSettingsRef]);

  const handleSubmit = (deviceIdValue) => {
    setTemporalVideoDevice(deviceIdValue)

    setSelectedVideoDevice(deviceIdValue);
  };

  if (videoDevices.length === 0) {
    return <div>No video devices available</div>;
  }

  return (
    <Box component="form" noValidate autoComplete="off">
      <Box>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Camera</InputLabel>
          <Select
            id="videoInputDevice"
            label="Camera"
            value={temporalVideoDevice ?? selectedVideoDevice}
            onChange={(e) => handleSubmit(e.target.value)}
            variant="outlined"
            fullWidth
          >
            {videoDevices.map((device) => (
              <MenuItem key={device.deviceId} value={device.deviceId} selected={device.deviceId === selectedVideoDevice}>
                {/* Rendering VideocamIcon alongside the text */}
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '5px', width: '25px', position: 'relative', top: '3px' }}>
                    {device.deviceId === selectedVideoDevice && <VideocamIcon fontSize="small" />}
                  </span>
                  <span>
                    {device.deviceId === selectedVideoDevice
                      ? `${device.label || `Device ${device.deviceId}`}`
                      : device.label || `Device ${device.deviceId}`}
                  </span>
                </span>
              </MenuItem>
            ))}

          </Select>
        </FormControl>
      </Box>

      <Box mt={2}>
        <video
          ref={myVideoSettingsRef}
          width={"100%"}
          height={"200px"}
          muted
          autoPlay
          playsInline
        />
      </Box>
    </Box>
  );
};

export default VideoSettings;
